import React from 'react';
import { Button } from '@mui/material';
import { formatLongDisplayDate } from '../../helpers';
import './Splash.css';

const Splash = (props: Props) => {
  return (
    <div className='splash padding flex flex-col items-center '>
      <div className='width-fit flex flex-col items-center gap-small'>
        <h2 className='flex flex-col items-center'>
          <span className='splash-subtitle'>Welcome to</span>
          <span className='splash-header'>WORMLE</span>
        </h2>
        <p className='splash-blurb'>
          Use the worm to fill in the grid and spell a themed word on each row.
        </p>
        <p className='splash-blurb'>Can you guess today&#39;s theme?</p>
        <p className='splash-date'>
          {props.gameDate ? formatLongDisplayDate(props.gameDate) : ''}
        </p>
        <Button
          className='splash-button'
          style={{ border: 'none' }}
          fullWidth
          variant='outlined'
          size='large'
          onClick={props.onStartRealGameClick}
        >
          Play
        </Button>
        <Button
          style={{ border: 'none' }}
          className='splash-button'
          variant='outlined'
          size='large'
          fullWidth
          onClick={props.onStartDemoClick}
        >
          Try demo
        </Button>
      </div>
    </div>
  );
};

interface Props {
  gameDate: string | undefined;
  onStartRealGameClick: () => void;
  onStartDemoClick: () => void;
}

export default Splash;
